import React from 'react'
import { Card } from '../../../../../atoms'

interface CalculatorCardProps {
  label: string
  value: string
  prefix?: string
  format?: 'thousands'
}

export const CalculatorCard = ({ label, value, prefix, format }: CalculatorCardProps) => {
  const formattedValue =
    format === 'thousands' ? value.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : value

  return (
    <Card variant='regular'>
      <div className='Calculator-card-label'>{label}</div>
      <div className='Calculator-card-content'>
        {prefix} {formattedValue}
      </div>
    </Card>
  )
}

export default CalculatorCard
